import { WEB_URL } from "@/config/endpoints";
import IMAGES from "@/public/assets/img";

export default {
  SeoContent:{
        title: 'Credlix News',
        url: WEB_URL+'/news',
        description:'List of News in Credlix',
        keyword: 'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company', 
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
 
  
  }